import { useSuccessGamblingContext } from '@/components/success-gambling/context';
import Copy from '@/components/success-gambling/components/copy';
import '@/components/success-gambling/components/lines/lines.css';

export default function CopyLines() {
  const { tips } = useSuccessGamblingContext();

  return (
    <div data-testid='copy-lines'>
      {tips.map((tip, index) => {
        switch (tip.type) {
          case 'separator':
            return <hr data-testid='separator' key={tip.type + index} className='success-gambling-lines-separator' />;
          case 'copy':
            return (
              <div data-testid='copy-text' key={tip.type + index} className='success-gambling-lines-copy'>
                <Copy title={tip.title} text={tip.text} twoLines={tip.twoLines} />
              </div>
            );
          default:
            return null;
        }
      })}
    </div>
  );
}
